module.exports = __webpack_public_path__ + "static/media/bottom_banner_6_2.ded74b43.png";